import { render } from "./ClienteCreate.vue?vue&type=template&id=1c8df159&scoped=true"
import script from "./ClienteCreate.vue?vue&type=script&lang=js"
export * from "./ClienteCreate.vue?vue&type=script&lang=js"

import "./ClienteCreate.vue?vue&type=style&index=0&id=1c8df159&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8df159"]])

export default __exports__